import { Link, useNavigate, useParams, useLoaderData } from "react-router-dom";
import { useState, useEffect } from "react";

import AnaliticasForm from "./AnaliticasForm";

import { AnaliticasUpdate } from "./AnaliticasUpdate";
import { AnaliticasDelete } from "./AnaliticasDelete";

export function AnaliticasEdit(props) {
  const analiticas = useLoaderData();
  const navigate = useNavigate();
  const errorLoadMessage = analiticas.message;

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);


  const [warningMessages, setWarningMessages] = useState([]);
  const [warningSecondMessages, setWarningSecondMessages] = useState([]);
  const [warningGeneralMessages, setWarningGeneralMessages] = useState([]);

  useEffect(() => {
    // Limpiar el estado de warningMessages cuando cambie la URL
    return () => {
      setWarningMessages([]);
      setWarningSecondMessages([]);
      setWarningGeneralMessages([]);
    };
  }, [window.location.pathname]);

  const [analiticaIsSecond, setAnaliticaIsSecond] = useState(
    analiticas.meta?.analiticaIsSecond
  );

  const [isNotJson, setIsNotJson] = useState(analiticas.meta?.isNotJson);

  useEffect(() => {
    console.log(analiticas.meta?.analiticaIsSecond);
    setAnaliticaIsSecond(analiticas.meta?.analiticaIsSecond);
  }, [analiticas]);

  

  const [analiFecha, setAnaliFecha] = useState(analiticas.meta?.metaFecha);

  const [analiFechaAnali, setAnaliFechaAnali] = useState(
    analiticas.meta?.analiFechaAnali
  );
  const [analiName, setAnaliName] = useState(analiticas.meta?.analiName);
  const [analiSurname, setAnaliSurname] = useState(
    analiticas.meta?.analiSurname
  );
  const [analiBed, setAnaliBed] = useState(analiticas.meta?.analiBed);
  const [analiNhc, setAnaliNhc] = useState(analiticas.meta?.analiNhc);
  const [analiDni, setAnaliDni] = useState(analiticas.meta?.analiDni);
  const [analiSex, setAnaliSex] = useState(analiticas.meta?.analiSex);
  const [analiOrigen, setAnaliOrigen] = useState(analiticas.meta?.analiOrigen);
  const [analiDoctor, setAnaliDoctor] = useState(analiticas.meta?.analiDoctor);
  const [analiObs, setAnaliObs] = useState(analiticas.meta?.analiObs);

  const [analiticaCompleta, setAnaliticaCompleta] = useState(null);

  useEffect(() => {
    console.log(isNotJson)
    if (!isNotJson) {
      try {
        const parsedJson = JSON.parse(analiticas.meta?.analiticaJson);
        setAnaliticaCompleta(parsedJson);
      } catch (error) {
        const errorMessage = "Error al analizar el JSON: " + error.message;
        console.error(errorMessage);
        setWarningGeneralMessages((prevMessages) => [
          ...prevMessages,
          errorMessage,
        ]);
      }
    }
  }, [analiticas.meta?.analiticaJson]);

  // Función para calcular los limites y resultados de las analiticas
  const createResultProperties = (result, low, high) => {
    // Convertir los strings que vienen del meta a numbers
    result = parseFloat(result);
    low = parseFloat(low);
    high = parseFloat(high);
    const color =
      result >= low && result <= high
        ? "anali-result-good"
        : "anali-result-bad";
    const markIn = Math.min(
      Math.max(((result - low) / (high - low)) * 100, 0),
      100
    );
    const markOut =
      result < low
        ? "anali-result-low"
        : result > high
        ? "anali-result-high"
        : "";

    return { color, markIn, markOut };
  };

  // Hematíes
  const [analiHematiesResult, setAnaliHematiesResult] = useState(
    analiticas.meta?.analiHematiesResult
  );
  const [analiHematiesLow, setAnaliHematiesLow] = useState(
    analiticas.meta?.analiHematiesLow
  );
  const [analiHematiesHigh, setAnaliHematiesHigh] = useState(
    analiticas.meta?.analiHematiesHigh
  );
  const {
    color: analiHematiesColor,
    markIn: analiHematiesMarkIn,
    markOut: analiHematiesMarkOut,
  } = createResultProperties(
    analiHematiesResult,
    analiHematiesLow,
    analiHematiesHigh
  );

  // Hemoglobina
  const [analiHemoglobResult, setAnaliHemoglobResult] = useState(
    analiticas.meta?.analiHemoglobResult
  );
  const [analiHemoglobLow, setAnaliHemoglobLow] = useState(
    analiticas.meta?.analiHemoglobLow
  );
  const [analiHemoglobHigh, setAnaliHemoglobHigh] = useState(
    analiticas.meta?.analiHemoglobHigh
  );
  const {
    color: analiHemoglobColor,
    markIn: analiHemoglobMarkIn,
    markOut: analiHemoglobMarkOut,
  } = createResultProperties(
    analiHematiesResult,
    analiHematiesLow,
    analiHemoglobHigh
  );

  // Hematocrito
  const [analiHematcrResult, setAnaliHematcrResult] = useState(
    analiticas.meta?.analiHematcrResult
  );
  const [analiHematcrLow, setAnaliHematcrLow] = useState(
    analiticas.meta?.analiHematcrLow
  );
  const [analiHematcrHigh, setAnaliHematcrHigh] = useState(
    analiticas.meta?.analiHematcrHigh
  );
  const {
    color: analiHematcrColor,
    markIn: analiHematcrMarkIn,
    markOut: analiHematcrMarkOut,
  } = createResultProperties(
    analiHematcrResult,
    analiHematcrLow,
    analiHematcrHigh
  );

  // VCM
  const [analiVcmResult, setAnaliVcmResult] = useState(
    analiticas.meta?.analiVcmResult
  );
  const [analiVcmLow, setAnaliVcmLow] = useState(analiticas.meta?.analiVcmLow);
  const [analiVcmHigh, setAnaliVcmHigh] = useState(
    analiticas.meta?.analiVcmHigh
  );
  const {
    color: analiVcmColor,
    markIn: analiVcmMarkIn,
    markOut: analiVcmMarkOut,
  } = createResultProperties(analiVcmResult, analiVcmLow, analiVcmHigh);

  // HCM
  const [analiHcmResult, setAnaliHcmResult] = useState(
    analiticas.meta?.analiHcmResult
  );
  const [analiHcmLow, setAnaliHcmLow] = useState(analiticas.meta?.analiHcmLow);
  const [analiHcmHigh, setAnaliHcmHigh] = useState(
    analiticas.meta?.analiHcmHigh
  );
  const {
    color: analiHcmColor,
    markIn: analiHcmMarkIn,
    markOut: analiHcmMarkOut,
  } = createResultProperties(analiHcmResult, analiHcmLow, analiHcmHigh);

  // CHCM
  const [analiChcmResult, setAnaliChcmResult] = useState(
    analiticas.meta?.analiChcmResult
  );
  const [analiChcmLow, setAnaliChcmLow] = useState(
    analiticas.meta?.analiChcmLow
  );
  const [analiChcmHigh, setAnaliChcmHigh] = useState(
    analiticas.meta?.analiChcmHigh
  );
  const {
    color: analiChcmColor,
    markIn: analiChcmMarkIn,
    markOut: analiChcmMarkOut,
  } = createResultProperties(analiChcmResult, analiChcmLow, analiChcmHigh);

  // IDH
  const [analiIdhResult, setAnaliIdhResult] = useState(
    analiticas.meta?.analiIdhResult
  );
  const [analiIdhLow, setAnaliIdhLow] = useState(analiticas.meta?.analiIdhLow);
  const [analiIdhHigh, setAnaliIdhHigh] = useState(
    analiticas.meta?.analiIdhHigh
  );
  const {
    color: analiIdhColor,
    markIn: analiIdhMarkIn,
    markOut: analiIdhMarkOut,
  } = createResultProperties(analiIdhResult, analiIdhLow, analiIdhHigh);

  // Leucocitos
  const [analiLeucoResult, setAnaliLeucoResult] = useState(
    analiticas.meta?.analiLeucoResult
  );
  const [analiLeucoLow, setAnaliLeucoLow] = useState(
    analiticas.meta?.analiLeucoLow
  );
  const [analiLeucoHigh, setAnaliLeucoHigh] = useState(
    analiticas.meta?.analiLeucoHigh
  );
  const {
    color: analiLeucoColor,
    markIn: analiLeucoMarkIn,
    markOut: analiLeucoMarkOut,
  } = createResultProperties(analiLeucoResult, analiLeucoLow, analiLeucoHigh);

  // Neutrófilos segmentados
  const [analiNeutrResult, setAnaliNeutrResult] = useState(
    analiticas.meta?.analiNeutrResult
  );
  const [analiNeutrLow, setAnaliNeutrLow] = useState(
    analiticas.meta?.analiNeutrLow
  );
  const [analiNeutrHigh, setAnaliNeutrHigh] = useState(
    analiticas.meta?.analiNeutrHigh
  );
  const {
    color: analiNeutrColor,
    markIn: analiNeutrMarkIn,
    markOut: analiNeutrMarkOut,
  } = createResultProperties(analiNeutrResult, analiNeutrLow, analiNeutrHigh);

  // Linfocitos
  const [analiLinfoResult, setAnaliLinfoResult] = useState(
    analiticas.meta?.analiLinfoResult
  );
  const [analiLinfoLow, setAnaliLinfoLow] = useState(
    analiticas.meta?.analiLinfoLow
  );
  const [analiLinfoHigh, setAnaliLinfoHigh] = useState(
    analiticas.meta?.analiLinfoHigh
  );
  const {
    color: analiLinfoColor,
    markIn: analiLinfoMarkIn,
    markOut: analiLinfoMarkOut,
  } = createResultProperties(analiLinfoResult, analiLinfoLow, analiLinfoHigh);

  // Monocitos
  const [analiMonocResult, setAnaliMonocResult] = useState(
    analiticas.meta?.analiMonocResult
  );
  const [analiMonocLow, setAnaliMonocLow] = useState(
    analiticas.meta?.analiMonocLow
  );
  const [analiMonocHigh, setAnaliMonocHigh] = useState(
    analiticas.meta?.analiMonocHigh
  );
  const {
    color: analiMonocColor,
    markIn: analiMonocMarkIn,
    markOut: analiMonocMarkOut,
  } = createResultProperties(analiMonocResult, analiMonocLow, analiMonocHigh);

  // Eosinófilos
  const [analiEosinResult, setAnaliEosinResult] = useState(
    analiticas.meta?.analiEosinResult
  );
  const [analiEosinLow, setAnaliEosinLow] = useState(
    analiticas.meta?.analiEosinLow
  );
  const [analiEosinHigh, setAnaliEosinHigh] = useState(
    analiticas.meta?.analiEosinHigh
  );
  const {
    color: analiEosinColor,
    markIn: analiEosinMarkIn,
    markOut: analiEosinMarkOut,
  } = createResultProperties(analiEosinResult, analiEosinLow, analiEosinHigh);

  // Basófilos
  const [analiBasofResult, setAnaliBasofResult] = useState(
    analiticas.meta?.analiBasofResult
  );
  const [analiBasofLow, setAnaliBasofLow] = useState(
    analiticas.meta?.analiBasofLow
  );
  const [analiBasofHigh, setAnaliBasofHigh] = useState(
    analiticas.meta?.analiBasofHigh
  );
  const {
    color: analiBasofColor,
    markIn: analiBasofMarkIn,
    markOut: analiBasofMarkOut,
  } = createResultProperties(analiBasofResult, analiBasofLow, analiBasofHigh);

  // Plaquetas
  const [analiPlaqResult, setAnaliPlaqResult] = useState(
    analiticas.meta?.analiPlaqResult
  );
  const [analiPlaqLow, setAnaliPlaqLow] = useState(
    analiticas.meta?.analiPlaqLow
  );
  const [analiPlaqHigh, setAnaliPlaqHigh] = useState(
    analiticas.meta?.analiPlaqHigh
  );
  const {
    color: analiPlaqColor,
    markIn: analiPlaqMarkIn,
    markOut: analiPlaqMarkOut,
  } = createResultProperties(analiPlaqResult, analiPlaqLow, analiPlaqHigh);

  // PCT
  const [analiPctResult, setAnaliPctResult] = useState(
    analiticas.meta?.analiPctResult
  );
  const [analiPctLow, setAnaliPctLow] = useState(analiticas.meta?.analiPctLow);
  const [analiPctHigh, setAnaliPctHigh] = useState(
    analiticas.meta?.analiPctHigh
  );
  const {
    color: analiPctColor,
    markIn: analiPctMarkIn,
    markOut: analiPctMarkOut,
  } = createResultProperties(analiPctResult, analiPctLow, analiPctHigh);

  // VPM
  const [analiVpmResult, setAnaliVpmResult] = useState(
    analiticas.meta?.analiVpmResult
  );
  const [analiVpmLow, setAnaliVpmLow] = useState(analiticas.meta?.analiVpmLow);
  const [analiVpmHigh, setAnaliVpmHigh] = useState(
    analiticas.meta?.analiVpmHigh
  );
  const {
    color: analiVpmColor,
    markIn: analiVpmMarkIn,
    markOut: analiVpmMarkOut,
  } = createResultProperties(analiVpmResult, analiVpmLow, analiVpmHigh);

  // IDP
  const [analiIdpResult, setAnaliIdpResult] = useState(
    analiticas.meta?.analiIdpResult
  );
  const [analiIdpLow, setAnaliIdpLow] = useState(analiticas.meta?.analiIdpLow);
  const [analiIdpHigh, setAnaliIdpHigh] = useState(
    analiticas.meta?.analiIdpHigh
  );
  const {
    color: analiIdpColor,
    markIn: analiIdpMarkIn,
    markOut: analiIdpMarkOut,
  } = createResultProperties(analiIdpResult, analiIdpLow, analiIdpHigh);

  // Tiempo de Protrombina (seg)
  const [analiTieProtResult, setAnaliTieProtResult] = useState(
    analiticas.meta?.analiTieProtResult
  );
  const [analiTieProtLow, setAnaliTieProtLow] = useState(
    analiticas.meta?.analiTieProtLow
  );
  const [analiTieProtHigh, setAnaliTieProtHigh] = useState(
    analiticas.meta?.analiTieProtHigh
  );
  const {
    color: analiTieProtColor,
    markIn: analiTieProtMarkIn,
    markOut: analiTieProtMarkOut,
  } = createResultProperties(
    analiTieProtResult,
    analiTieProtLow,
    analiTieProtHigh
  );

  // Actividad de Protrombina (%)
  const [analiActProtResult, setAnaliActProtResult] = useState(
    analiticas.meta?.analiActProtResult
  );
  const [analiActProtLow, setAnaliActProtLow] = useState(
    analiticas.meta?.analiActProtLow
  );
  const [analiActProtHigh, setAnaliActProtHigh] = useState(
    analiticas.meta?.analiActProtHigh
  );
  const {
    color: analiActProtColor,
    markIn: analiActProtMarkIn,
    markOut: analiActProtMarkOut,
  } = createResultProperties(
    analiActProtResult,
    analiActProtLow,
    analiActProtHigh
  );

  // INR
  const [analiInrResult, setAnaliInrResult] = useState(
    analiticas.meta?.analiInrResult
  );
  const [analiInrLow, setAnaliInrLow] = useState(analiticas.meta?.analiInrLow);
  const [analiInrHigh, setAnaliInrHigh] = useState(
    analiticas.meta?.analiInrHigh
  );
  const {
    color: analiInrColor,
    markIn: analiInrMarkIn,
    markOut: analiInrMarkOut,
  } = createResultProperties(analiInrResult, analiInrLow, analiInrHigh);

  // Glucosa, Suero/Pl
  const [analiGlucResult, setAnaliGlucResult] = useState(
    analiticas.meta?.analiGlucResult
  );
  const [analiGlucLow, setAnaliGlucLow] = useState(
    analiticas.meta?.analiGlucLow
  );
  const [analiGlucHigh, setAnaliGlucHigh] = useState(
    analiticas.meta?.analiGlucHigh
  );
  const {
    color: analiGlucColor,
    markIn: analiGlucMarkIn,
    markOut: analiGlucMarkOut,
  } = createResultProperties(analiGlucResult, analiGlucLow, analiGlucHigh);

  // Urea, Suero/Pl
  const [analiUreaResult, setAnaliUreaResult] = useState(
    analiticas.meta?.analiUreaResult
  );
  const [analiUreaLow, setAnaliUreaLow] = useState(
    analiticas.meta?.analiUreaLow
  );
  const [analiUreaHigh, setAnaliUreaHigh] = useState(
    analiticas.meta?.analiUreaHigh
  );
  const {
    color: analiUreaColor,
    markIn: analiUreaMarkIn,
    markOut: analiUreaMarkOut,
  } = createResultProperties(analiUreaResult, analiUreaLow, analiUreaHigh);

  // Creatinina, Suero/Pl
  const [analiCreatResult, setAnaliCreatResult] = useState(
    analiticas.meta?.analiCreatResult
  );
  const [analiCreatLow, setAnaliCreatLow] = useState(
    analiticas.meta?.analiCreatLow
  );
  const [analiCreatHigh, setAnaliCreatHigh] = useState(
    analiticas.meta?.analiCreatHigh
  );
  const {
    color: analiCreatColor,
    markIn: analiCreatMarkIn,
    markOut: analiCreatMarkOut,
  } = createResultProperties(analiCreatResult, analiCreatLow, analiCreatHigh);

  // Filtrado Glomerular CKD-EPI
  const [analiGlomResult, setAnaliGlomResult] = useState(
    analiticas.meta?.analiGlomResult
  );
  const [analiGlomLow, setAnaliGlomLow] = useState(
    analiticas.meta?.analiGlomLow
  );
  const [analiGlomHigh, setAnaliGlomHigh] = useState(
    analiticas.meta?.analiGlomHigh
  );
  const {
    color: analiGlomColor,
    markIn: analiGlomMarkIn,
    markOut: analiGlomMarkOut,
  } = createResultProperties(analiGlomResult, analiGlomLow, analiGlomHigh);

  // Aspartato Amino Transferasa (AST/GOT), Suero/Pl
  const [analiAsparResult, setAnaliAsparResult] = useState(
    analiticas.meta?.analiAsparResult
  );
  const [analiAsparLow, setAnaliAsparLow] = useState(
    analiticas.meta?.analiAsparLow
  );
  const [analiAsparHigh, setAnaliAsparHigh] = useState(
    analiticas.meta?.analiAsparHigh
  );
  const {
    color: analiAsparColor,
    markIn: analiAsparMarkIn,
    markOut: analiAsparMarkOut,
  } = createResultProperties(analiAsparResult, analiAsparLow, analiAsparHigh);

  // Alanina Amino Transferasa (ALT/GPT), Suero/Pl
  const [analiAlanResult, setAnaliAlanResult] = useState(
    analiticas.meta?.analiAlanResult
  );
  const [analiAlanLow, setAnaliAlanLow] = useState(
    analiticas.meta?.analiAlanLow
  );
  const [analiAlanHigh, setAnaliAlanHigh] = useState(
    analiticas.meta?.analiAlanHigh
  );
  const {
    color: analiAlanColor,
    markIn: analiAlanMarkIn,
    markOut: analiAlanMarkOut,
  } = createResultProperties(analiAlanResult, analiAlanLow, analiAlanHigh);

  // Gamma Glutamil Transferasa (GGT), Suero/Pl
  const [analiGammResult, setAnaliGammResult] = useState(
    analiticas.meta?.analiGammResult
  );
  const [analiGammLow, setAnaliGammLow] = useState(
    analiticas.meta?.analiGammLow
  );
  const [analiGammHigh, setAnaliGammHigh] = useState(
    analiticas.meta?.analiGammHigh
  );
  const {
    color: analiGammColor,
    markIn: analiGammMarkIn,
    markOut: analiGammMarkOut,
  } = createResultProperties(analiGammResult, analiGammLow, analiGammHigh);

  // Fosfatasa Alcalina (FA), Suero/Pl
  const [analiFosfResult, setAnaliFosfResult] = useState(
    analiticas.meta?.analiFosfResult
  );
  const [analiFosfLow, setAnaliFosfLow] = useState(
    analiticas.meta?.analiFosfLow
  );
  const [analiFosfHigh, setAnaliFosfHigh] = useState(
    analiticas.meta?.analiFosfHigh
  );
  const {
    color: analiFosfColor,
    markIn: analiFosfMarkIn,
    markOut: analiFosfMarkOut,
  } = createResultProperties(analiFosfResult, analiFosfLow, analiFosfHigh);

  // Bilirrubina total, Suero/Pl
  const [analiBiliResult, setAnaliBiliResult] = useState(
    analiticas.meta?.analiBiliResult
  );
  const [analiBiliLow, setAnaliBiliLow] = useState(
    analiticas.meta?.analiBiliLow
  );
  const [analiBiliHigh, setAnaliBiliHigh] = useState(
    analiticas.meta?.analiBiliHigh
  );
  const {
    color: analiBiliColor,
    markIn: analiBiliMarkIn,
    markOut: analiBiliMarkOut,
  } = createResultProperties(analiBiliResult, analiBiliLow, analiBiliHigh);

  // Colesterol, Suero/Pl
  const [analiColestResult, setAnaliColestResult] = useState(
    analiticas.meta?.analiColestResult
  );
  const [analiColestLow, setAnaliColestLow] = useState(
    analiticas.meta?.analiColestLow
  );
  const [analiColestHigh, setAnaliColestHigh] = useState(
    analiticas.meta?.analiColestHigh
  );
  const {
    color: analiColestColor,
    markIn: analiColestMarkIn,
    markOut: analiColestMarkOut,
  } = createResultProperties(
    analiColestResult,
    analiColestLow,
    analiColestHigh
  );

  // Colesterol HDL, Suero/Pl
  const [analiColestHdlResult, setAnaliColestHdlResult] = useState(
    analiticas.meta?.analiColestHdlResult
  );
  const [analiColestHdlLow, setAnaliColestHdlLow] = useState(
    analiticas.meta?.analiColestHdlLow
  );
  const [analiColestHdlHigh, setAnaliColestHdlHigh] = useState(
    analiticas.meta?.analiColestHdlHigh
  );
  const {
    color: analiColestHdlColor,
    markIn: analiColestHdlMarkIn,
    markOut: analiColestHdlMarkOut,
  } = createResultProperties(
    analiColestHdlResult,
    analiColestHdlLow,
    analiColestHdlHigh
  );

  // Colesterol LDL, Suero/Pl
  const [analiColestLdlResult, setAnaliColestLdlResult] = useState(
    analiticas.meta?.analiColestLdlResult
  );
  const [analiColestLdlLow, setAnaliColestLdlLow] = useState(
    analiticas.meta?.analiColestLdlLow
  );
  const [analiColestLdlHigh, setAnaliColestLdlHigh] = useState(
    analiticas.meta?.analiColestLdlHigh
  );
  const {
    color: analiColestLdlColor,
    markIn: analiColestLdlMarkIn,
    markOut: analiColestLdlMarkOut,
  } = createResultProperties(
    analiColestLdlResult,
    analiColestLdlLow,
    analiColestLdlHigh
  );

  // Triglicéridos, Suero/Pl
  const [analiTriglResult, setAnaliTriglResult] = useState(
    analiticas.meta?.analiTriglResult
  );
  const [analiTriglLow, setAnaliTriglLow] = useState(
    analiticas.meta?.analiTriglLow
  );
  const [analiTriglHigh, setAnaliTriglHigh] = useState(
    analiticas.meta?.analiTriglHigh
  );
  const {
    color: analiTriglColor,
    markIn: analiTriglMarkIn,
    markOut: analiTriglMarkOut,
  } = createResultProperties(analiTriglResult, analiTriglLow, analiTriglHigh);

  // Calcio, Suero/Pl
  const [analiCalcResult, setAnaliCalcResult] = useState(
    analiticas.meta?.analiCalcResult
  );
  const [analiCalcLow, setAnaliCalcLow] = useState(
    analiticas.meta?.analiCalcLow
  );
  const [analiCalcHigh, setAnaliCalcHigh] = useState(
    analiticas.meta?.analiCalcHigh
  );
  const {
    color: analiCalcColor,
    markIn: analiCalcMarkIn,
    markOut: analiCalcMarkOut,
  } = createResultProperties(analiCalcResult, analiCalcLow, analiCalcHigh);

  // Hierro, Suero/Pl
  const [analiHierrResult, setAnaliHierrResult] = useState(
    analiticas.meta?.analiHierrResult
  );
  const [analiHierrLow, setAnaliHierrLow] = useState(
    analiticas.meta?.analiHierrLow
  );
  const [analiHierrHigh, setAnaliHierrHigh] = useState(
    analiticas.meta?.analiHierrHigh
  );
  const {
    color: analiHierrColor,
    markIn: analiHierrMarkIn,
    markOut: analiHierrMarkOut,
  } = createResultProperties(analiHierrResult, analiHierrLow, analiHierrHigh);

  // Sodio, Suero/Pl
  const [analiSodResult, setAnaliSodResult] = useState(
    analiticas.meta?.analiSodResult
  );
  const [analiSodLow, setAnaliSodLow] = useState(analiticas.meta?.analiSodLow);
  const [analiSodHigh, setAnaliSodHigh] = useState(
    analiticas.meta?.analiSodHigh
  );
  const {
    color: analiSodColor,
    markIn: analiSodMarkIn,
    markOut: analiSodMarkOut,
  } = createResultProperties(analiSodResult, analiSodLow, analiSodHigh);

  // Potasio, Suero/Pl
  const [analiPotasResult, setAnaliPotasResult] = useState(
    analiticas.meta?.analiPotasResult
  );
  const [analiPotasLow, setAnaliPotasLow] = useState(
    analiticas.meta?.analiPotasLow
  );
  const [analiPotasHigh, setAnaliPotasHigh] = useState(
    analiticas.meta?.analiPotasHigh
  );
  const {
    color: analiPotasColor,
    markIn: analiPotasMarkIn,
    markOut: analiPotasMarkOut,
  } = createResultProperties(analiPotasResult, analiPotasLow, analiPotasHigh);

  // Vitamina B12, Suero/Pl
  const [analiVitbResult, setAnaliVitbResult] = useState(
    analiticas.meta?.analiVitbResult
  );
  const [analiVitbLow, setAnaliVitbLow] = useState(
    analiticas.meta?.analiVitbLow
  );
  const [analiVitbHigh, setAnaliVitbHigh] = useState(
    analiticas.meta?.analiVitbHigh
  );
  const {
    color: analiVitbColor,
    markIn: analiVitbMarkIn,
    markOut: analiVitbMarkOut,
  } = createResultProperties(analiVitbResult, analiVitbLow, analiVitbHigh);

  // 25-OH Vitamina D
  const [analiVitohResult, setAnaliVitohResult] = useState(
    analiticas.meta?.analiVitohResult
  );
  const [analiVitohLow, setAnaliVitohLow] = useState(
    analiticas.meta?.analiVitohLow
  );
  const [analiVitohHigh, setAnaliVitohHigh] = useState(
    analiticas.meta?.analiVitohHigh
  );
  const {
    color: analiVitohColor,
    markIn: analiVitohMarkIn,
    markOut: analiVitohMarkOut,
  } = createResultProperties(analiVitohResult, analiVitohLow, analiVitohHigh);

  // Ácido Fólico Folato, Suero/Pl
  const [analiAcidfolResult, setAnaliAcidfolResult] = useState(
    analiticas.meta?.analiAcidfolResult
  );
  const [analiAcidfolLow, setAnaliAcidfolLow] = useState(
    analiticas.meta?.analiAcidfolLow
  );
  const [analiAcidfolHigh, setAnaliAcidfolHigh] = useState(
    analiticas.meta?.analiAcidfolHigh
  );
  const {
    color: analiAcidfolColor,
    markIn: analiAcidfolMarkIn,
    markOut: analiAcidfolMarkOut,
  } = createResultProperties(
    analiAcidfolResult,
    analiAcidfolLow,
    analiAcidfolHigh
  );

  // Magnesio, Suero/Pl
  const [analiMagnResult, setAnaliMagnResult] = useState(
    analiticas.meta?.analiMagnResult
  );
  const [analiMagnLow, setAnaliMagnLow] = useState(
    analiticas.meta?.analiMagnLow
  );
  const [analiMagnHigh, setAnaliMagnHigh] = useState(
    analiticas.meta?.analiMagnHigh
  );
  const {
    color: analiMagnColor,
    markIn: analiMagnMarkIn,
    markOut: analiMagnMarkOut,
  } = createResultProperties(analiMagnResult, analiMagnLow, analiMagnHigh);

  // Ferritina, Suero/Pl
  const [analiFerriResult, setAnaliFerriResult] = useState(
    analiticas.meta?.analiFerriResult
  );
  const [analiFerriLow, setAnaliFerriLow] = useState(
    analiticas.meta?.analiFerriLow
  );
  const [analiFerriHigh, setAnaliFerriHigh] = useState(
    analiticas.meta?.analiFerriHigh
  );
  const {
    color: analiFerriColor,
    markIn: analiFerriMarkIn,
    markOut: analiFerriMarkOut,
  } = createResultProperties(analiFerriResult, analiFerriLow, analiFerriHigh);

  // Proteína C Reactiva (PCR), Suero/Pl
  const [analiProtcResult, setAnaliProtcResult] = useState(
    analiticas.meta?.analiProtcResult
  );
  const [analiProtcLow, setAnaliProtcLow] = useState(
    analiticas.meta?.analiProtcLow
  );
  const [analiProtcHigh, setAnaliProtcHigh] = useState(
    analiticas.meta?.analiProtcHigh
  );
  const {
    color: analiProtcColor,
    markIn: analiProtcMarkIn,
    markOut: analiProtcMarkOut,
  } = createResultProperties(analiProtcResult, analiProtcLow, analiProtcHigh);

  // Cortisol
  const [analiCortiResult, setAnaliCortiResult] = useState(
    analiticas.meta?.analiCortiResult
  );
  const [analiCortiLow, setAnaliCortiLow] = useState(
    analiticas.meta?.analiCortiLow
  );
  const [analiCortiHigh, setAnaliCortiHigh] = useState(
    analiticas.meta?.analiCortiHigh
  );
  const {
    color: analiCortiColor,
    markIn: analiCortiMarkIn,
    markOut: analiCortiMarkOut,
  } = createResultProperties(analiCortiResult, analiCortiLow, analiCortiHigh);

  // DHEA
  const [analiDheaResult, setAnaliDheaResult] = useState(
    analiticas.meta?.analiDheaResult
  );
  const [analiDheaLow, setAnaliDheaLow] = useState(
    analiticas.meta?.analiDheaLow
  );
  const [analiDheaHigh, setAnaliDheaHigh] = useState(
    analiticas.meta?.analiDheaHigh
  );
  const {
    color: analiDheaColor,
    markIn: analiDheaMarkIn,
    markOut: analiDheaMarkOut,
  } = createResultProperties(analiDheaResult, analiDheaLow, analiDheaHigh);

  // DHEA-S
  const [analiDheaSResult, setAnaliDheaSResult] = useState(
    analiticas.meta?.analiDheaSResult
  );
  const [analiDheaSLow, setAnaliDheaSLow] = useState(
    analiticas.meta?.analiDheaSLow
  );
  const [analiDheaSHigh, setAnaliDheaSHigh] = useState(
    analiticas.meta?.analiDheaSHigh
  );
  const {
    color: analiDheaSColor,
    markIn: analiDheaSMarkIn,
    markOut: analiDheaSMarkOut,
  } = createResultProperties(analiDheaSResult, analiDheaSLow, analiDheaSHigh);

  let { tratamientoId } = useParams();
  let { pacienteId } = useParams();
  let analiticasId = analiticas.id;
  console.log(analiticasId)
  const analiDate = new Date(analiticas.date);
  const diffDate = Math.abs(new Date() - analiDate) / 36e5;

  useEffect(() => {
    if (
      analiCortiResult != null ||
      analiDheaResult != null ||
      analiDheaSResult != null
    ) {
      setAnaliticaIsSecond(true);
    } else {
      setAnaliticaIsSecond(false);
    }
  }, [analiCortiResult, analiDheaResult, analiDheaSResult]);

  const convertToString = (value) => (value !== undefined ? value.toString() : "");

  const submitAnaliticas = async (e) => {
    e.preventDefault();
    setIsCreatingButton(true);
    console.log(
      analiFecha,
      analiFechaAnali,
      analiName,
      analiSurname,
      analiBed,
      analiNhc,
      analiDni,
      analiSex,
      analiOrigen,
      analiDoctor,
      analiObs,
      analiHematiesResult,
      analiHematiesLow,
      analiHematiesHigh,
      analiHemoglobResult,
      analiHemoglobLow,
      analiHemoglobHigh,
      analiHematcrResult,
      analiHematcrLow,
      analiHematcrHigh,
      analiVcmResult,
      analiVcmLow,
      analiVcmHigh,
      analiHcmResult,
      analiHcmLow,
      analiHcmHigh,
      analiChcmResult,
      analiChcmLow,
      analiChcmHigh,
      analiIdhResult,
      analiIdhLow,
      analiIdhHigh,
      analiLeucoResult,
      analiLeucoLow,
      analiLeucoHigh,
      analiNeutrResult,
      analiNeutrLow,
      analiNeutrHigh,
      analiLinfoResult,
      analiLinfoLow,
      analiLinfoHigh,
      analiMonocResult,
      analiMonocLow,
      analiMonocHigh,
      analiEosinResult,
      analiEosinLow,
      analiEosinHigh,
      analiBasofResult,
      analiBasofLow,
      analiBasofHigh,
      analiPlaqResult,
      analiPlaqLow,
      analiPlaqHigh,
      analiPctResult,
      analiPctLow,
      analiPctHigh,
      analiVpmResult,
      analiVpmLow,
      analiVpmHigh,
      analiIdpResult,
      analiIdpLow,
      analiIdpHigh,
      analiTieProtResult,
      analiTieProtLow,
      analiTieProtHigh,
      analiActProtResult,
      analiActProtLow,
      analiActProtHigh,
      analiInrResult,
      analiInrLow,
      analiInrHigh,
      analiGlucResult,
      analiGlucLow,
      analiGlucHigh,
      analiUreaResult,
      analiUreaLow,
      analiUreaHigh,
      analiCreatResult,
      analiCreatLow,
      analiCreatHigh,
      analiGlomResult,
      analiGlomLow,
      analiGlomHigh,
      analiAsparResult,
      analiAsparLow,
      analiAsparHigh,
      analiAlanResult,
      analiAlanLow,
      analiAlanHigh,
      analiGammResult,
      analiGammLow,
      analiGammHigh,
      analiFosfResult,
      analiFosfLow,
      analiFosfHigh,
      analiBiliResult,
      analiBiliLow,
      analiBiliHigh,
      analiColestResult,
      analiColestLow,
      analiColestHigh,
      analiColestHdlResult,
      analiColestHdlLow,
      analiColestHdlHigh,
      analiColestLdlResult,
      analiColestLdlLow,
      analiColestLdlHigh,
      analiTriglResult,
      analiTriglLow,
      analiTriglHigh,
      analiCalcResult,
      analiCalcLow,
      analiCalcHigh,
      analiHierrResult,
      analiHierrLow,
      analiHierrHigh,
      analiSodResult,
      analiSodLow,
      analiSodHigh,
      analiPotasResult,
      analiPotasLow,
      analiPotasHigh,
      analiVitbResult,
      analiVitbLow,
      analiVitbHigh,
      analiVitohResult,
      analiVitohLow,
      analiVitohHigh,
      analiAcidfolResult,
      analiAcidfolLow,
      analiAcidfolHigh,
      analiMagnResult,
      analiMagnLow,
      analiMagnHigh,
      analiFerriResult,
      analiFerriLow,
      analiFerriHigh,
      analiProtcResult,
      analiProtcLow,
      analiProtcHigh,
      analiCortiResult,
      analiCortiLow,
      analiCortiHigh,
      analiDheaResult,
      analiDheaLow,
      analiDheaHigh,
      analiDheaSResult,
      analiDheaSLow,
      analiDheaSHigh,
      isNotJson,
      analiticaIsSecond,
      tratamientoId,
      pacienteId,
      analiticasId
    );
    try {
      await AnaliticasUpdate(
        analiFecha,
        analiFechaAnali,
        analiName,
        analiSurname,
        analiBed,
        analiNhc,
        analiDni,
        analiSex,
        analiOrigen,
        analiDoctor,
        analiObs,
        convertToString(analiHematiesResult),
        convertToString(analiHematiesLow),
        convertToString(analiHematiesHigh),
        convertToString(analiHemoglobResult),
        convertToString(analiHemoglobLow),
        convertToString(analiHemoglobHigh),
        convertToString(analiHematcrResult),
        convertToString(analiHematcrLow),
        convertToString(analiHematcrHigh),
        convertToString(analiVcmResult),
        convertToString(analiVcmLow),
        convertToString(analiVcmHigh),
        convertToString(analiHcmResult),
        convertToString(analiHcmLow),
        convertToString(analiHcmHigh),
        convertToString(analiChcmResult),
        convertToString(analiChcmLow),
        convertToString(analiChcmHigh),
        convertToString(analiIdhResult),
        convertToString(analiIdhLow),
        convertToString(analiIdhHigh),
        convertToString(analiLeucoResult),
        convertToString(analiLeucoLow),
        convertToString(analiLeucoHigh),
        convertToString(analiNeutrResult),
        convertToString(analiNeutrLow),
        convertToString(analiNeutrHigh),
        convertToString(analiLinfoResult),
        convertToString(analiLinfoLow),
        convertToString(analiLinfoHigh),
        convertToString(analiMonocResult),
        convertToString(analiMonocLow),
        convertToString(analiMonocHigh),
        convertToString(analiEosinResult),
        convertToString(analiEosinLow),
        convertToString(analiEosinHigh),
        convertToString(analiBasofResult),
        convertToString(analiBasofLow),
        convertToString(analiBasofHigh),
        convertToString(analiPlaqResult),
        convertToString(analiPlaqLow),
        convertToString(analiPlaqHigh),
        convertToString(analiPctResult),
        convertToString(analiPctLow),
        convertToString(analiPctHigh),
        convertToString(analiVpmResult),
        convertToString(analiVpmLow),
        convertToString(analiVpmHigh),
        convertToString(analiIdpResult),
        convertToString(analiIdpLow),
        convertToString(analiIdpHigh),
        convertToString(analiTieProtResult),
        convertToString(analiTieProtLow),
        convertToString(analiTieProtHigh),
        convertToString(analiActProtResult),
        convertToString(analiActProtLow),
        convertToString(analiActProtHigh),
        convertToString(analiInrResult),
        convertToString(analiInrLow),
        convertToString(analiInrHigh),
        convertToString(analiGlucResult),
        convertToString(analiGlucLow),
        convertToString(analiGlucHigh),
        convertToString(analiUreaResult),
        convertToString(analiUreaLow),
        convertToString(analiUreaHigh),
        convertToString(analiCreatResult),
        convertToString(analiCreatLow),
        convertToString(analiCreatHigh),
        convertToString(analiGlomResult),
        convertToString(analiGlomLow),
        convertToString(analiGlomHigh),
        convertToString(analiAsparResult),
        convertToString(analiAsparLow),
        convertToString(analiAsparHigh),
        convertToString(analiAlanResult),
        convertToString(analiAlanLow),
        convertToString(analiAlanHigh),
        convertToString(analiGammResult),
        convertToString(analiGammLow),
        convertToString(analiGammHigh),
        convertToString(analiFosfResult),
        convertToString(analiFosfLow),
        convertToString(analiFosfHigh),
        convertToString(analiBiliResult),
        convertToString(analiBiliLow),
        convertToString(analiBiliHigh),
        convertToString(analiColestResult),
        convertToString(analiColestLow),
        convertToString(analiColestHigh),
        convertToString(analiColestHdlResult),
        convertToString(analiColestHdlLow),
        convertToString(analiColestHdlHigh),
        convertToString(analiColestLdlResult),
        convertToString(analiColestLdlLow),
        convertToString(analiColestLdlHigh),
        convertToString(analiTriglResult),
        convertToString(analiTriglLow),
        convertToString(analiTriglHigh),
        convertToString(analiCalcResult),
        convertToString(analiCalcLow),
        convertToString(analiCalcHigh),
        convertToString(analiHierrResult),
        convertToString(analiHierrLow),
        convertToString(analiHierrHigh),
        convertToString(analiSodResult),
        convertToString(analiSodLow),
        convertToString(analiSodHigh),
        convertToString(analiPotasResult),
        convertToString(analiPotasLow),
        convertToString(analiPotasHigh),
        convertToString(analiVitbResult),
        convertToString(analiVitbLow),
        convertToString(analiVitbHigh),
        convertToString(analiVitohResult),
        convertToString(analiVitohLow),
        convertToString(analiVitohHigh),
        convertToString(analiAcidfolResult),
        convertToString(analiAcidfolLow),
        convertToString(analiAcidfolHigh),
        convertToString(analiMagnResult),
        convertToString(analiMagnLow),
        convertToString(analiMagnHigh),
        convertToString(analiFerriResult),
        convertToString(analiFerriLow),
        convertToString(analiFerriHigh),
        convertToString(analiProtcResult),
        convertToString(analiProtcLow),
        convertToString(analiProtcHigh),
        convertToString(analiCortiResult),
        convertToString(analiCortiLow),
        convertToString(analiCortiHigh),
        convertToString(analiDheaResult),
        convertToString(analiDheaLow),
        convertToString(analiDheaHigh),
        convertToString(analiDheaSResult),
        convertToString(analiDheaSLow),
        convertToString(analiDheaSHigh),
        isNotJson,
        analiticaIsSecond,
        tratamientoId,
        pacienteId,
        analiticasId
      ).then(
        (val) => {
          navigate(`../${tratamientoId}/analiticas/${analiticasId}`);
          //console.log(val)
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  const deleteItem = async (e) => {
    e.preventDefault();
    setIsDeletingButton(true);
    try {
      await AnaliticasDelete(analiticasId).then(
        (val) => {
          window.location.replace("../");
          //console.log(val)
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div id="content">
        {analiticas.length === 0 ? (
          <div>Cargando...</div>
        ) : errorLoadMessage ? (
          <p>{errorLoadMessage}</p>
        ) : (
          <form id="formUpdatelement" onSubmit={submitAnaliticas}>
            <fieldset id="disabledContainer">
              {/* {analiticaIsSecond &&
                (warningGeneralMessages.length > 0 ||
                  warningSecondMessages.length > 0) && (
                  <div className="warning-message notification is-danger is-light">
                    <p>Se han encontrado los siguiente errores:</p>
                    <ul>
                      {warningGeneralMessages
                        .concat(warningSecondMessages)
                        .map((message, index) => (
                          <li key={index}>{message}</li>
                        ))}
                    </ul>
                  </div>
                )} */}

              {/* {!analiticaIsSecond &&
                (warningMessages.length > 0 ||
                  warningGeneralMessages.length > 0) && (
                  <div className="warning-message notification is-danger is-light">
                    <p>Se han encontrado los siguiente errores:</p>
                    <ul>
                      {warningMessages
                        .concat(warningGeneralMessages)
                        .map((message, index) => (
                          <li key={index}>{message}</li>
                        ))}
                    </ul>
                  </div>
                )} */}

              {!isNotJson && (
                <>
                  <div className="grid--2col">
                    <div className="field">
                      <label htmlFor="analiFecha">Fecha visita</label>
                      <div className="control">
                        <input
                          className="input"
                          id="analiFecha"
                          required
                          type="date"
                          value={analiFecha}
                          onChange={(e) => setAnaliFecha(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="field">
                      <label htmlFor="analiFechaAnali">Fecha Analítica</label>
                      <div className="control">
                        <input
                          className="input"
                          id="analiFechaAnali"
                          required
                          type="date"
                          readOnly
                          value={analiFechaAnali}
                          onChange={(e) => setAnaliFechaAnali(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="analitic-form">
                    <h3>Informe del laboratorio</h3>
                    <div className="grid--2col">
                      <div className="field">
                        <label htmlFor="analiName">Nombre Paciente</label>
                        <div className="control">
                          <input
                            className="input"
                            id="analiName"
                            required
                            type="text"
                            readOnly
                            value={analiName}
                          />
                        </div>
                      </div>
                      <div className="field">
                        <label htmlFor="analiSurname">Apellido paciente</label>
                        <div className="control">
                          <input
                            className="input"
                            id="analiSurname"
                            required
                            type="text"
                            readOnly
                            value={analiSurname}
                          />
                        </div>
                      </div>
                      <div className="field">
                        <label htmlFor="analiDni">DNI</label>
                        <div className="control">
                          <input
                            className="input"
                            id="analiDni"
                            required
                            type="text"
                            readOnly
                            value={analiDni}
                          />
                        </div>
                      </div>
                      <div className="field">
                        <label htmlFor="analiNhc">NHC</label>
                        <div className="control">
                          <input
                            className="input"
                            id="analiNhc"
                            required
                            type="number"
                            readOnly
                            value={analiNhc}
                          />
                        </div>
                      </div>
                      <div className="field">
                        <label htmlFor="analiBed">Cama</label>
                        <div className="control">
                          <input
                            className="input"
                            id="analiBed"
                            required
                            type="text"
                            readOnly
                            value={analiBed}
                          />
                        </div>
                      </div>
                      <div className="field">
                        <label htmlFor="analiSex">Sexo</label>
                        <div className="control">
                          <input
                            className="input"
                            id="analiSex"
                            required
                            type="text"
                            readOnly
                            value={analiSex}
                          />
                        </div>
                      </div>
                      <div className="field">
                        <label htmlFor="analiOrigen">Origen</label>
                        <div className="control">
                          <input
                            className="input"
                            id="analiOrigen"
                            required
                            type="text"
                            readOnly
                            value={analiOrigen}
                          />
                        </div>
                      </div>
                      <div className="field">
                        <label htmlFor="analiDoctor">Doctor</label>
                        <div className="control">
                          <input
                            className="input"
                            id="analiDoctor"
                            required
                            type="text"
                            readOnly
                            value={analiDoctor}
                          />
                        </div>
                      </div>
                      <div className="field">
                        <label htmlFor="analiObs">Observaciones</label>
                        <div className="control">
                          <input
                            className="input"
                            id="analiObs"
                            type="textarea"
                            readOnly
                            value={analiObs}
                          />
                        </div>
                      </div>
                    </div>
                    {(analiHematiesResult ||
                      analiHemoglobResult ||
                      analiHematcrResult ||
                      analiVcmResult ||
                      analiHcmResult ||
                      analiChcmResult ||
                      analiIdhResult ||
                      analiLeucoResult ||
                      analiNeutrResult ||
                      analiLinfoResult ||
                      analiMonocResult ||
                      analiEosinResult ||
                      analiBasofResult ||
                      analiPlaqResult ||
                      analiPctResult ||
                      analiVpmResult ||
                      analiIdpResult) && (
                      <>
                        <h3>Hematología</h3>
                        <div className="three-col-analitic">
                          {analiHematiesResult ? (
                            <div className="anali-el">
                              <p className="anali-title">Hematies</p>
                              <div className="anali-result-container">
                                <p
                                  className={`anali-result ${analiHematiesColor}`}
                                >
                                  {analiHematiesResult}
                                </p>
                                <p className="anali-units">
                                  x10<sup>6</sup>/μL
                                </p>
                                <div
                                  className={`anali-bar-full ${analiHematiesMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{
                                        left: `${analiHematiesMarkIn}%`,
                                      }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiHematiesLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiHematiesHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {analiHemoglobResult ? (
                            <div className="anali-el">
                              <p className="anali-title">Hemoglobina</p>
                              <div className="anali-result-container">
                                <p
                                  className={`anali-result ${analiHemoglobColor}`}
                                >
                                  {analiHemoglobResult}
                                </p>
                                <p className="anali-units">g/dL</p>
                                <div
                                  className={`anali-bar-full ${analiHemoglobMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{
                                        left: `${analiHemoglobMarkIn}%`,
                                      }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiHemoglobLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiHemoglobHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {analiHematcrResult ? (
                            <div className="anali-el">
                              <p className="anali-title">Hematocrito</p>
                              <div className="anali-result-container">
                                <p
                                  className={`anali-result ${analiHematcrColor}`}
                                >
                                  {analiHematcrResult}
                                </p>
                                <p className="anali-units">%</p>
                                <div
                                  className={`anali-bar-full ${analiHematcrMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiHematcrMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiHematcrLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiHematcrHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}

                          {analiVcmResult ? (
                            <div className="anali-el">
                              <p className="anali-title">VCM</p>
                              <div className="anali-result-container">
                                <p className={`anali-result ${analiVcmColor}`}>
                                  {analiVcmResult}
                                </p>
                                <p className="anali-units">fL</p>
                                <div
                                  className={`anali-bar-full ${analiVcmMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiVcmMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiVcmLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiVcmHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}

                          {analiHcmResult ? (
                            <div className="anali-el">
                              <p className="anali-title">HCM</p>
                              <div className="anali-result-container">
                                <p className={`anali-result ${analiHcmColor}`}>
                                  {analiHcmResult}
                                </p>
                                <p className="anali-units">pg/cél</p>
                                <div
                                  className={`anali-bar-full ${analiHcmMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiHcmMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiHcmLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiHcmHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}

                          {analiChcmResult ? (
                            <div className="anali-el">
                              <p className="anali-title">CHCM</p>
                              <div className="anali-result-container">
                                <p className={`anali-result ${analiChcmColor}`}>
                                  {analiChcmResult}
                                </p>
                                <p className="anali-units">g/dL</p>
                                <div
                                  className={`anali-bar-full ${analiChcmMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiChcmMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiChcmLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiChcmHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}

                          {analiIdhResult ? (
                            <div className="anali-el">
                              <p className="anali-title">IDH</p>
                              <div className="anali-result-container">
                                <p className={`anali-result ${analiIdhColor}`}>
                                  {analiIdhResult}
                                </p>
                                <p className="anali-units">%</p>
                                <div
                                  className={`anali-bar-full ${analiIdhMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiIdhMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiIdhLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiIdhHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}

                          {analiLeucoResult ? (
                            <div className="anali-el">
                              <p className="anali-title">Leucocitos</p>
                              <div className="anali-result-container">
                                <p
                                  className={`anali-result ${analiLeucoColor}`}
                                >
                                  {analiLeucoResult}
                                </p>
                                <p className="anali-units">
                                  x10<sup>3</sup>/μL
                                </p>
                                <div
                                  className={`anali-bar-full ${analiLeucoMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiLeucoMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiLeucoLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiLeucoHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}

                          {analiNeutrResult ? (
                            <div className="anali-el">
                              <p className="anali-title">
                                Neutrófilos segmentados
                              </p>
                              <div className="anali-result-container">
                                <p
                                  className={`anali-result ${analiNeutrColor}`}
                                >
                                  {analiNeutrResult}
                                </p>
                                <p className="anali-units"></p>
                                <div
                                  className={`anali-bar-full ${analiNeutrMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiNeutrMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiNeutrLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiNeutrHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}

                          {analiLinfoResult ? (
                            <div className="anali-el">
                              <p className="anali-title">Linfocitos</p>
                              <div className="anali-result-container">
                                <p
                                  className={`anali-result ${analiLinfoColor}`}
                                >
                                  {analiLinfoResult}
                                </p>
                                <p className="anali-units">
                                  x10<sup>3</sup>/μL
                                </p>
                                <div
                                  className={`anali-bar-full ${analiLinfoMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiLinfoMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiLinfoLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiLinfoHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}

                          {analiMonocResult ? (
                            <div className="anali-el">
                              <p className="anali-title">Monocitos</p>
                              <div className="anali-result-container">
                                <p
                                  className={`anali-result ${analiMonocColor}`}
                                >
                                  {analiMonocResult}
                                </p>
                                <p className="anali-units">
                                  x10<sup>3</sup>/μL
                                </p>
                                <div
                                  className={`anali-bar-full ${analiMonocMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiMonocMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiMonocLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiMonocHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}

                          {analiEosinResult ? (
                            <div className="anali-el">
                              <p className="anali-title">Eosinófilos</p>
                              <div className="anali-result-container">
                                <p
                                  className={`anali-result ${analiEosinColor}`}
                                >
                                  {analiEosinResult}
                                </p>
                                <p className="anali-units">
                                  x10<sup>3</sup>/μL
                                </p>
                                <div
                                  className={`anali-bar-full ${analiEosinMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiEosinMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiEosinLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiEosinHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}

                          {analiBasofResult ? (
                            <div className="anali-el">
                              <p className="anali-title">Basófilos</p>
                              <div className="anali-result-container">
                                <p
                                  className={`anali-result ${analiBasofColor}`}
                                >
                                  {analiBasofResult}
                                </p>
                                <p className="anali-units">
                                  x10<sup>3</sup>/μL
                                </p>
                                <div
                                  className={`anali-bar-full ${analiBasofMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiBasofMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiBasofLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiBasofHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}

                          {analiPlaqResult ? (
                            <div className="anali-el">
                              <p className="anali-title">Plaquetas</p>
                              <div className="anali-result-container">
                                <p className={`anali-result ${analiPlaqColor}`}>
                                  {analiPlaqResult}
                                </p>
                                <p className="anali-units">
                                  x10<sup>3</sup>/μL
                                </p>
                                <div
                                  className={`anali-bar-full ${analiPlaqMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiPlaqMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiPlaqLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiPlaqHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}

                          {analiPctResult ? (
                            <div className="anali-el">
                              <p className="anali-title">PCT</p>
                              <div className="anali-result-container">
                                <p className={`anali-result ${analiPctColor}`}>
                                  {analiPctResult}
                                </p>
                                <p className="anali-units">%</p>
                                <div
                                  className={`anali-bar-full ${analiPctMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiPctMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiPctLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiPctHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}

                          {analiVpmResult ? (
                            <div className="anali-el">
                              <p className="anali-title">VPM</p>
                              <div className="anali-result-container">
                                <p className={`anali-result ${analiVpmColor}`}>
                                  {analiVpmResult}
                                </p>
                                <p className="anali-units">fL</p>
                                <div
                                  className={`anali-bar-full ${analiVpmMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiVpmMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiVpmLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiVpmHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}

                          {analiIdpResult ? (
                            <div className="anali-el">
                              <p className="anali-title">IDP</p>
                              <div className="anali-result-container">
                                <p className={`anali-result ${analiIdpColor}`}>
                                  {analiIdpResult}
                                </p>
                                <p className="anali-units">%</p>
                                <div
                                  className={`anali-bar-full ${analiIdpMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiIdpMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiIdpLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiIdpHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </>
                    )}
                    {(analiTieProtResult ||
                      analiActProtResult ||
                      analiInrResult) && (
                      <>
                        <h3>Coagulación</h3>
                        <div className="three-col-analitic">
                          {analiTieProtResult ? (
                            <div className="anali-el">
                              <p className="anali-title">
                                Tiempo de Protrombina (seg)
                              </p>
                              <div className="anali-result-container">
                                <p
                                  className={`anali-result ${analiTieProtColor}`}
                                >
                                  {analiTieProtResult}
                                </p>
                                <p className="anali-units">seg</p>
                                <div
                                  className={`anali-bar-full ${analiTieProtMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiTieProtMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiTieProtLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiTieProtHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}

                          {analiActProtResult ? (
                            <div className="anali-el">
                              <p className="anali-title">
                                Actividad de Protrombina (%)
                              </p>
                              <div className="anali-result-container">
                                <p
                                  className={`anali-result ${analiActProtColor}`}
                                >
                                  {analiActProtResult}
                                </p>
                                <p className="anali-units">%</p>
                                <div
                                  className={`anali-bar-full ${analiActProtMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiActProtMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiActProtLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiActProtHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {analiInrResult ? (
                            <div className="anali-el">
                              <p className="anali-title">INR</p>
                              <div className="anali-result-container">
                                <p className={`anali-result ${analiInrColor}`}>
                                  {analiInrResult}
                                </p>
                                <p className="anali-units"></p>
                                <div
                                  className={`anali-bar-full ${analiInrMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiInrMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiInrLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiInrHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </>
                    )}
                    {(analiGlucResult ||
                      analiUreaResult ||
                      analiCreatResult ||
                      analiGlomResult ||
                      analiAsparResult ||
                      analiAlanResult ||
                      analiGammResult ||
                      analiFosfResult ||
                      analiBiliResult ||
                      analiColestResult ||
                      analiColestHdlResult ||
                      analiColestLdlResult ||
                      analiTriglResult ||
                      analiCalcResult ||
                      analiHierrResult ||
                      analiSodResult ||
                      analiPotasResult ||
                      analiVitbResult ||
                      analiVitohResult ||
                      analiAcidfolResult ||
                      analiMagnResult) && (
                      <>
                        <h3>Bioquímica</h3>
                        <div className="three-col-analitic">
                          {analiGlucResult ? (
                            <div className="anali-el">
                              <p className="anali-title">Glucosa, Suero/Pl</p>
                              <div className="anali-result-container">
                                <p className={`anali-result ${analiGlucColor}`}>
                                  {analiGlucResult}
                                </p>
                                <p className="anali-units">mg/dL</p>
                                <div
                                  className={`anali-bar-full ${analiGlucMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiGlucMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiGlucLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiGlucHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {analiUreaResult ? (
                            <div className="anali-el">
                              <p className="anali-title">Urea, Suero/Pl</p>
                              <div className="anali-result-container">
                                <p className={`anali-result ${analiUreaColor}`}>
                                  {analiUreaResult}
                                </p>
                                <p className="anali-units">mg/dL</p>
                                <div
                                  className={`anali-bar-full ${analiUreaMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiUreaMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiUreaLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiUreaHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {analiCreatResult ? (
                            <div className="anali-el">
                              <p className="anali-title">
                                Creatinina, Suero/Pl
                              </p>
                              <div className="anali-result-container">
                                <p
                                  className={`anali-result ${analiCreatColor}`}
                                >
                                  {analiCreatResult}
                                </p>
                                <p className="anali-units">mg/dL</p>
                                <div
                                  className={`anali-bar-full ${analiCreatMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiCreatMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiCreatLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiCreatHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {analiGlomResult ? (
                            <div className="anali-el">
                              <p className="anali-title">
                                Filtrado Glomerular CKD-EPI
                              </p>
                              <div className="anali-result-container">
                                <p className={`anali-result ${analiGlomColor}`}>
                                  {analiGlomResult}
                                </p>
                                <p className="anali-units">mL/min/1,7</p>
                                <div
                                  className={`anali-bar-full ${analiGlomMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiGlomMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiGlomLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiGlomHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {analiAsparResult ? (
                            <div className="anali-el">
                              <p className="anali-title">
                                Aspartato Amino Transferasa (AST/GOT), Suero/Pl
                              </p>
                              <div className="anali-result-container">
                                <p
                                  className={`anali-result ${analiAsparColor}`}
                                >
                                  {analiAsparResult}
                                </p>
                                <p className="anali-units">U/L</p>
                                <div
                                  className={`anali-bar-full ${analiAsparMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiAsparMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiAsparLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiAsparHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {analiAlanResult ? (
                            <div className="anali-el">
                              <p className="anali-title">
                                Alanina Amino Transferasa (ALT/GPT), Suero/Pl
                              </p>
                              <div className="anali-result-container">
                                <p className={`anali-result ${analiAlanColor}`}>
                                  {analiAlanResult}
                                </p>
                                <p className="anali-units">U/L</p>
                                <div
                                  className={`anali-bar-full ${analiAlanMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiAlanMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiAlanLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiAlanHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {analiGammResult ? (
                            <div className="anali-el">
                              <p className="anali-title">
                                Gamma Glutamil Transferasa (GGT), Suero/Pl
                              </p>
                              <div className="anali-result-container">
                                <p className={`anali-result ${analiGammColor}`}>
                                  {analiGammResult}
                                </p>
                                <p className="anali-units">U/L</p>
                                <div
                                  className={`anali-bar-full ${analiGammMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiGammMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiGammLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiGammHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {analiFosfResult ? (
                            <div className="anali-el">
                              <p className="anali-title">
                                Fosfatasa Alcalina (FA), Suero/Pl{" "}
                              </p>
                              <div className="anali-result-container">
                                <p className={`anali-result ${analiFosfColor}`}>
                                  {analiFosfResult}
                                </p>
                                <p className="anali-units">U/L</p>
                                <div
                                  className={`anali-bar-full ${analiFosfMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiFosfMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiFosfLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiFosfHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {analiBiliResult ? (
                            <div className="anali-el">
                              <p className="anali-title">
                                Bilirrubina total, Suero/Pl
                              </p>
                              <div className="anali-result-container">
                                <p className={`anali-result ${analiBiliColor}`}>
                                  {analiBiliResult}
                                </p>
                                <p className="anali-units">mg/dL</p>
                                <div
                                  className={`anali-bar-full ${analiBiliMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiBiliMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiBiliLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiBiliHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {analiColestResult ? (
                            <div className="anali-el">
                              <p className="anali-title">
                                Colesterol, Suero/Pl
                              </p>
                              <div className="anali-result-container">
                                <p
                                  className={`anali-result ${analiColestColor}`}
                                >
                                  {analiColestResult}
                                </p>
                                <p className="anali-units">mg/dL</p>
                                <div
                                  className={`anali-bar-full ${analiColestMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiColestMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiColestLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiColestHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {analiColestHdlResult ? (
                            <div className="anali-el">
                              <p className="anali-title">
                                Colesterol HDL, Suero/Pl
                              </p>
                              <div className="anali-result-container">
                                <p
                                  className={`anali-result ${analiColestHdlColor}`}
                                >
                                  {analiColestHdlResult}
                                </p>
                                <p className="anali-units">mg/dL</p>
                                <div
                                  className={`anali-bar-full ${analiColestHdlMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{
                                        left: `${analiColestHdlMarkIn}%`,
                                      }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiColestHdlLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiColestHdlHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {analiColestLdlResult ? (
                            <div className="anali-el">
                              <p className="anali-title">
                                Colesterol LDL, Suero/Pl
                              </p>
                              <div className="anali-result-container">
                                <p
                                  className={`anali-result ${analiColestLdlColor}`}
                                >
                                  {analiColestLdlResult}
                                </p>
                                <p className="anali-units">mg/dL</p>
                                <div
                                  className={`anali-bar-full ${analiColestLdlMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{
                                        left: `${analiColestLdlMarkIn}%`,
                                      }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiColestLdlLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiColestLdlHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {analiTriglResult ? (
                            <div className="anali-el">
                              <p className="anali-title">
                                Triglicéridos, Suero/Pl
                              </p>
                              <div className="anali-result-container">
                                <p
                                  className={`anali-result ${analiTriglColor}`}
                                >
                                  {analiTriglResult}
                                </p>
                                <p className="anali-units">mg/dL</p>
                                <div
                                  className={`anali-bar-full ${analiTriglMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiTriglMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiTriglLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiTriglHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {analiCalcResult ? (
                            <div className="anali-el">
                              <p className="anali-title">Calcio, Suero/Pl</p>
                              <div className="anali-result-container">
                                <p className={`anali-result ${analiCalcColor}`}>
                                  {analiCalcResult}
                                </p>
                                <p className="anali-units">mg/dL</p>
                                <div
                                  className={`anali-bar-full ${analiCalcMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiCalcMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiCalcLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiCalcHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {analiHierrResult ? (
                            <div className="anali-el">
                              <p className="anali-title">Hierro, Suero/Pl</p>
                              <div className="anali-result-container">
                                <p
                                  className={`anali-result ${analiHierrColor}`}
                                >
                                  {analiHierrResult}
                                </p>
                                <p className="anali-units">μg/dL</p>
                                <div
                                  className={`anali-bar-full ${analiHierrMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiHierrMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiHierrLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiHierrHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {analiSodResult ? (
                            <div className="anali-el">
                              <p className="anali-title">Sodio, Suero/Pl</p>
                              <div className="anali-result-container">
                                <p className={`anali-result ${analiSodColor}`}>
                                  {analiSodResult}
                                </p>
                                <p className="anali-units">mMol/L</p>
                                <div
                                  className={`anali-bar-full ${analiSodMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiSodMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiSodLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiSodHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {analiPotasResult ? (
                            <div className="anali-el">
                              <p className="anali-title">Potasio, Suero/Pl</p>
                              <div className="anali-result-container">
                                <p
                                  className={`anali-result ${analiPotasColor}`}
                                >
                                  {analiPotasResult}
                                </p>
                                <p className="anali-units">mMol/L</p>
                                <div
                                  className={`anali-bar-full ${analiPotasMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiPotasMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiPotasLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiPotasHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {analiVitbResult ? (
                            <div className="anali-el">
                              <p className="anali-title">
                                Vitamina B12, Suero/Pl
                              </p>
                              <div className="anali-result-container">
                                <p className={`anali-result ${analiVitbColor}`}>
                                  {analiVitbResult}
                                </p>
                                <p className="anali-units">pg/mL</p>
                                <div
                                  className={`anali-bar-full ${analiVitbMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiVitbMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiVitbLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiVitbHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {analiVitohResult ? (
                            <div className="anali-el">
                              <p className="anali-title">25-OH Vitamina D</p>
                              <div className="anali-result-container">
                                <p
                                  className={`anali-result ${analiVitohColor}`}
                                >
                                  {analiVitohResult}
                                </p>
                                <p className="anali-units">ng/mL</p>
                                <div
                                  className={`anali-bar-full ${analiVitohMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiVitohMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiVitohLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiVitohHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {analiAcidfolResult ? (
                            <div className="anali-el">
                              <p className="anali-title">
                                Acido Folico Folato, Suero/Pl
                              </p>
                              <div className="anali-result-container">
                                <p
                                  className={`anali-result ${analiAcidfolColor}`}
                                >
                                  {analiAcidfolResult}
                                </p>
                                <p className="anali-units">ng/mL</p>
                                <div
                                  className={`anali-bar-full ${analiAcidfolMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiAcidfolMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiAcidfolLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiAcidfolHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {analiMagnResult ? (
                            <div className="anali-el">
                              <p className="anali-title">Magnesio, Suero/Pl</p>
                              <div className="anali-result-container">
                                <p className={`anali-result ${analiMagnColor}`}>
                                  {analiMagnResult}
                                </p>
                                <p className="anali-units">mg/dL</p>
                                <div
                                  className={`anali-bar-full ${analiMagnMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiMagnMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiMagnLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiMagnHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </>
                    )}
                    {(analiFerriResult || analiProtcResult) && (
                      <>
                        <h3>Proteínas</h3>
                        <div className="three-col-analitic">
                          {analiFerriResult ? (
                            <div className="anali-el">
                              <p className="anali-title">Ferritina, Suero/Pl</p>
                              <div className="anali-result-container">
                                <p
                                  className={`anali-result ${analiFerriColor}`}
                                >
                                  {analiFerriResult}
                                </p>
                                <p className="anali-units">ng/mL</p>
                                <div
                                  className={`anali-bar-full ${analiFerriMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiFerriMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiFerriLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiFerriHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {analiProtcResult ? (
                            <div className="anali-el">
                              <p className="anali-title">
                                Proteína C Reactiva (PCR), Suero/Pl
                              </p>
                              <div className="anali-result-container">
                                <p
                                  className={`anali-result ${analiProtcColor}`}
                                >
                                  {analiProtcResult}
                                </p>
                                <p className="anali-units">mg/L</p>
                                <div
                                  className={`anali-bar-full ${analiProtcMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiProtcMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiProtcLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiProtcHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </>
                    )}
                    {(analiCortiResult ||
                      analiDheaResult ||
                      analiDheaSResult) && (
                      <>
                        <h3>Analitica B</h3>
                        <div className="three-col-analitic">
                          {analiCortiResult ? (
                            <div className="anali-el">
                              <p className="anali-title">Cortisol</p>
                              <div className="anali-result-container">
                                <p
                                  className={`anali-result ${analiCortiColor}`}
                                >
                                  {analiCortiResult}
                                </p>
                                <p className="anali-units">g/dL</p>
                                <div
                                  className={`anali-bar-full ${analiCortiMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiCortiMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiCortiLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiCortiHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {analiDheaResult ? (
                            <div className="anali-el">
                              <p className="anali-title">DHEA</p>
                              <div className="anali-result-container">
                                <p className={`anali-result ${analiDheaColor}`}>
                                  {analiDheaResult}
                                </p>
                                <p className="anali-units">ng/mL</p>
                                <div
                                  className={`anali-bar-full ${analiDheaMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiDheaMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiDheaLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiDheaHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {analiDheaSResult ? (
                            <div className="anali-el">
                              <p className="anali-title">DHEA-S</p>
                              <div className="anali-result-container">
                                <p
                                  className={`anali-result ${analiDheaSColor}`}
                                >
                                  {analiDheaSResult}
                                </p>
                                <p className="anali-units">g/mL</p>
                                <div
                                  className={`anali-bar-full ${analiDheaSMarkOut}`}
                                >
                                  <div className="anali-bar anali-bar-low"></div>
                                  <div className="anali-bar anali-bar-main">
                                    <div
                                      className="anali-bar-mark"
                                      style={{ left: `${analiDheaSMarkIn}%` }}
                                    ></div>
                                  </div>
                                  <div className="anali-bar anali-bar-high"></div>
                                </div>
                                <div className="anali-limit-container">
                                  <p className="anali-limit anali-limit-low">
                                    {analiDheaSLow}
                                  </p>
                                  <p className="anali-limit anali-limit-high">
                                    {analiDheaSHigh}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </>
                    )}
                  </div>
                </>
              )}

              {isNotJson && (
                <>
                  <h3>
                    Edición Analítica subida manualmente
                  </h3>
                  <div className="grid--2col">
                    <div className="field">
                      <label htmlFor="analiFecha">Fecha visita</label>
                      <div className="control">
                        <input
                          className="input"
                          id="analiFecha"
                          required
                          type="date"
                          value={analiFecha}
                          onChange={(e) => setAnaliFecha(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="field">
                      <label htmlFor="analiFechaAnali">Fecha Analítica</label>
                      <div className="control">
                        <input
                          className="input"
                          id="analiFechaAnali"
                          required
                          type="date"
                          value={analiFechaAnali}
                          onChange={(e) => setAnaliFechaAnali(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="analitic-form">
                  <h3>Informe del laboratorio</h3>
                  <div className="grid--2col">
                    <div className="field">
                      <label htmlFor="analiName">Nombre paciente</label>
                      <div className="control">
                        <input
                          className="input"
                          id="analiName"
                          required
                          type="text"
                          value={analiName}
                          onChange={(e) => setAnaliName(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="field">
                      <label htmlFor="analiSurname">Apellido paciente</label>
                      <div className="control">
                        <input
                          className="input"
                          id="analiSurname"
                          required
                          type="text"
                          value={analiSurname}
                          onChange={(e) => setAnaliSurname(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="field">
                      <label htmlFor="analiDni">DNI</label>
                      <div className="control">
                        <input
                          className="input"
                          id="analiDni"
                          required
                          type="text"
                          value={analiDni}
                          onChange={(e) => setAnaliDni(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="field">
                      <label htmlFor="analiNhc">NHC</label>
                      <div className="control">
                        <input
                          className="input"
                          id="analiNhc"
                          required
                          type="number"
                          value={analiNhc}
                          onChange={(e) => setAnaliNhc(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="field">
                      <label htmlFor="analiBed">Cama</label>
                      <div className="control">
                        <input
                          className="input"
                          id="analiBed"
                          required
                          type="text"
                          value={analiBed}
                          onChange={(e) => setAnaliBed(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="field">
                      <label htmlFor="analiSex">Sexo</label>
                      <div className="control">
                        <input
                          className="input"
                          id="analiSex"
                          required
                          type="text"
                          value={analiSex}
                          onChange={(e) => setAnaliSex(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="field">
                      <label htmlFor="analiOrigen">Origen</label>
                      <div className="control">
                        <input
                          className="input"
                          id="analiOrigen"
                          required
                          type="text"
                          value={analiOrigen}
                          onChange={(e) => setAnaliOrigen(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="field">
                      <label htmlFor="analiDoctor">Doctor</label>
                      <div className="control">
                        <input
                          className="input"
                          id="analiDoctor"
                          required
                          type="text"
                          value={analiDoctor}
                          onChange={(e) => setAnaliDoctor(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="field">
                      <label htmlFor="analiObs">Observaciones</label>
                      <div className="control">
                        <input
                          className="input"
                          id="analiObs"
                          type="textarea"
                          value={analiObs}
                          onChange={(e) => setAnaliObs(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                    <h3>Hematología</h3>
                    <div className="grid--4col">
                      {/* Hematies empty field  */}
                      <div className="field">
                        <h4>
                          Hematies{" "}
                          <i>
                            (x10<sup>6</sup>/μL)
                          </i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiHematiesResult"
                            type="number"
                            value={analiHematiesResult}
                            onChange={(e) => setAnaliHematiesResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiHematiesLow"
                            type="number"
                            value={analiHematiesLow}
                            onChange={(e) => setAnaliHematiesLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiHematiesHigh"
                            type="number"
                            value={analiHematiesHigh}
                            onChange={(e) => setAnaliHematiesHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* Hemoglobina empty field  */}
                      <div className="field">
                        <h4>
                          Hemoglobina <i>(g/dL)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiHemoglobResult"
                            type="number"
                            value={analiHemoglobResult}
                            onChange={(e) => setAnaliHemoglobResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiHemoglobLow"
                            type="number"
                            value={analiHemoglobLow}
                            onChange={(e) => setAnaliHemoglobLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiHemoglobHigh"
                            type="number"
                            value={analiHemoglobHigh}
                            onChange={(e) => setAnaliHemoglobHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* Hematocrito empty field  */}
                      <div className="field">
                        <h4>
                          Hematocrito <i>(%)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiHematcrResult"
                            type="number"
                            value={analiHematcrResult}
                            onChange={(e) => setAnaliHematcrResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiHematcrLow"
                            type="number"
                            value={analiHematcrLow}
                            onChange={(e) => setAnaliHematcrLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiHematcrHigh"
                            type="number"
                            value={analiHematcrHigh}
                            onChange={(e) => setAnaliHematcrHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* VCM empty field  */}
                      <div className="field">
                        <h4>
                          VCM <i>(fL)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiVcmResult"
                            type="number"
                            value={analiVcmResult}
                            onChange={(e) => setAnaliVcmResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiVcmLow"
                            type="number"
                            value={analiVcmLow}
                            onChange={(e) => setAnaliVcmLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiVcmHigh"
                            type="number"
                            value={analiVcmHigh}
                            onChange={(e) => setAnaliVcmHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* HCM empty field  */}
                      <div className="field">
                        <h4>
                          HCM <i>(pg/cél)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiHcmResult"
                            type="number"
                            value={analiHcmResult}
                            onChange={(e) => setAnaliHcmResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiHcmLow"
                            type="number"
                            value={analiHcmLow}
                            onChange={(e) => setAnaliHcmLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiHcmHigh"
                            type="number"
                            value={analiHcmHigh}
                            onChange={(e) => setAnaliHcmHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* CHCM empty field  */}
                      <div className="field">
                        <h4>
                          CHCM <i>(g/dL)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiChcmResult"
                            type="number"
                            value={analiChcmResult}
                            onChange={(e) => setAnaliChcmResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiChcmLow"
                            type="number"
                            value={analiChcmLow}
                            onChange={(e) => setAnaliChcmLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiChcmHigh"
                            type="number"
                            value={analiChcmHigh}
                            onChange={(e) => setAnaliChcmHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* IDH empty field  */}
                      <div className="field">
                        <h4>
                          IDH <i>(%)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiIdhResult"
                            type="number"
                            value={analiIdhResult}
                            onChange={(e) => setAnaliIdhResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiIdhLow"
                            type="number"
                            value={analiIdhLow}
                            onChange={(e) => setAnaliIdhLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiIdhHigh"
                            type="number"
                            value={analiIdhHigh}
                            onChange={(e) => setAnaliIdhHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>

                      {/* Hematies empty field  */}
                      <div className="field">
                        <h4>
                          Leucocitos{" "}
                          <i>
                            (x10<sup>3</sup>/μL)
                          </i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiLeucoResult"
                            type="number"
                            value={analiLeucoResult}
                            onChange={(e) => setAnaliLeucoResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiLeucoLow"
                            type="number"
                            value={analiLeucoLow}
                            onChange={(e) => setAnaliLeucoLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiLeucoHigh"
                            type="number"
                            value={analiLeucoHigh}
                            onChange={(e) => setAnaliLeucoHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* Neutrófilos segmentados empty field  */}
                      <div className="field">
                        <h4>
                          Neutrófilos segmentados{" "}
                          <i>
                            (x10<sup>3</sup>/μL)
                          </i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiNeutrResult"
                            type="number"
                            value={analiNeutrResult}
                            onChange={(e) => setAnaliNeutrResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiNeutrLow"
                            type="number"
                            value={analiNeutrLow}
                            onChange={(e) => setAnaliNeutrLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiNeutrHigh"
                            type="number"
                            value={analiNeutrHigh}
                            onChange={(e) => setAnaliNeutrHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* Linfocitos empty field  */}
                      <div className="field">
                        <h4>
                          Linfocitos{" "}
                          <i>
                            (x10<sup>3</sup>/μL)
                          </i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiLinfoResult"
                            type="number"
                            value={analiLinfoResult}
                            onChange={(e) => setAnaliLinfoResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiLinfoLow"
                            type="number"
                            value={analiLinfoLow}
                            onChange={(e) => setAnaliLinfoLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiLinfoHigh"
                            type="number"
                            value={analiLinfoHigh}
                            onChange={(e) => setAnaliLinfoHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* Monocitos empty field  */}
                      <div className="field">
                        <h4>
                          Monocitos{" "}
                          <i>
                            (x10<sup>3</sup>/μL)
                          </i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiMonocResult"
                            type="number"
                            value={analiMonocResult}
                            onChange={(e) => setAnaliMonocResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiMonocLow"
                            type="number"
                            value={analiMonocLow}
                            onChange={(e) => setAnaliMonocLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiMonocHigh"
                            type="number"
                            value={analiMonocHigh}
                            onChange={(e) => setAnaliMonocHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* Eosinófilos empty field  */}
                      <div className="field">
                        <h4>
                          Eosinófilos{" "}
                          <i>
                            (x10<sup>3</sup>/μL)
                          </i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiEosinResult"
                            type="number"
                            value={analiEosinResult}
                            onChange={(e) => setAnaliEosinResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiEosinLow"
                            type="number"
                            value={analiEosinLow}
                            onChange={(e) => setAnaliEosinLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiEosinHigh"
                            type="number"
                            value={analiEosinHigh}
                            onChange={(e) => setAnaliEosinHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* Basófilos empty field  */}
                      <div className="field">
                        <h4>
                          Basófilos{" "}
                          <i>
                            (x10<sup>3</sup>/μL)
                          </i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiBasofResult"
                            type="number"
                            value={analiBasofResult}
                            onChange={(e) => setAnaliBasofResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiBasofLow"
                            type="number"
                            value={analiBasofLow}
                            onChange={(e) => setAnaliBasofLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiBasofHigh"
                            type="number"
                            value={analiBasofHigh}
                            onChange={(e) => setAnaliBasofHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* Plaquetas empty field  */}
                      <div className="field">
                        <h4>
                          Plaquetas{" "}
                          <i>
                            (x10<sup>3</sup>/μL)
                          </i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiPlaqResult"
                            type="number"
                            value={analiPlaqResult}
                            onChange={(e) => setAnaliPlaqResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiPlaqLow"
                            type="number"
                            value={analiPlaqLow}
                            onChange={(e) => setAnaliPlaqLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiPlaqHigh"
                            type="number"
                            value={analiPlaqHigh}
                            onChange={(e) => setAnaliPlaqHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* PCT empty field  */}
                      <div className="field">
                        <h4>
                          PCT <i>(%)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiPctResult"
                            type="number"
                            value={analiPctResult}
                            onChange={(e) => setAnaliPctResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiPctLow"
                            type="number"
                            value={analiPctLow}
                            onChange={(e) => setAnaliPctLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiPctHigh"
                            type="number"
                            value={analiPctHigh}
                            onChange={(e) => setAnaliPctHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* VPM empty field  */}
                      <div className="field">
                        <h4>
                          VPM <i>(fL)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiVpmResult"
                            type="number"
                            value={analiVpmResult}
                            onChange={(e) => setAnaliVpmResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiVpmLow"
                            type="number"
                            value={analiVpmLow}
                            onChange={(e) => setAnaliVpmLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiVpmHigh"
                            type="number"
                            value={analiVpmHigh}
                            onChange={(e) => setAnaliVpmHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* IDP empty field  */}
                      <div className="field">
                        <h4>
                          IDP <i>(%)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiIdpResult"
                            type="number"
                            value={analiIdpResult}
                            onChange={(e) => setAnaliIdpResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiIdpLow"
                            type="number"
                            value={analiIdpLow}
                            onChange={(e) => setAnaliIdpLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiIdpHigh"
                            type="number"
                            value={analiIdpHigh}
                            onChange={(e) => setAnaliIdpHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                    </div>
                    <h3>Coagulación</h3>
                    <div className="grid--4col">
                      {/* Tiempo de Protrombina empty field  */}
                      <div className="field">
                        <h4>
                          Tiempo de Protrombina <i>(seg)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiTieProtResult"
                            type="number"
                            value={analiTieProtResult}
                            onChange={(e) => setAnaliTieProtResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiTieProtLow"
                            type="number"
                            value={analiTieProtLow}
                            onChange={(e) => setAnaliTieProtLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiTieProtHigh"
                            type="number"
                            value={analiTieProtHigh}
                            onChange={(e) => setAnaliTieProtHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* Actividad de Protrombina empty field  */}
                      <div className="field">
                        <h4>
                          Actividad de Protrombina <i>(%)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiActProtResult"
                            type="number"
                            value={analiActProtResult}
                            onChange={(e) => setAnaliActProtResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiActProtLow"
                            type="number"
                            value={analiActProtLow}
                            onChange={(e) => setAnaliActProtLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiActProtHigh"
                            type="number"
                            value={analiActProtHigh}
                            onChange={(e) => setAnaliActProtHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* INR empty field  */}
                      <div className="field">
                        <h4>INR </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiInrResult"
                            type="number"
                            value={analiInrResult}
                            onChange={(e) => setAnaliInrResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiInrLow"
                            type="number"
                            value={analiInrLow}
                            onChange={(e) => setAnaliInrLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiInrHigh"
                            type="number"
                            value={analiInrHigh}
                            onChange={(e) => setAnaliInrHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                    </div>
                    <h3>Bioquímica</h3>
                    <div className="grid--4col">
                      {/* Glucosa, Suero/Pl empty field  */}
                      <div className="field">
                        <h4>
                          Glucosa, Suero/Pl{" "}
                          <i>
                            (x10<sup>6</sup>/μL)
                          </i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiGlucResult"
                            type="number"
                            value={analiGlucResult}
                            onChange={(e) => setAnaliGlucResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiGlucLow"
                            type="number"
                            value={analiGlucLow}
                            onChange={(e) => setAnaliGlucLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiGlucHigh"
                            type="number"
                            value={analiGlucHigh}
                            onChange={(e) => setAnaliGlucHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* Urea, Suero/Pl empty field  */}
                      <div className="field">
                        <h4>
                          Urea, Suero/Pl <i>(mg/dL)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiUreaResult"
                            type="number"
                            value={analiUreaResult}
                            onChange={(e) => setAnaliUreaResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiUreaLow"
                            type="number"
                            value={analiUreaLow}
                            onChange={(e) => setAnaliUreaLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiUreaHigh"
                            type="number"
                            value={analiUreaHigh}
                            onChange={(e) => setAnaliUreaHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* Creatinina, Suero/Pl empty field  */}
                      <div className="field">
                        <h4>
                          Creatinina, Suero/Pl <i>(mg/dL)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiCreatResult"
                            type="number"
                            value={analiCreatResult}
                            onChange={(e) => setAnaliCreatResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiCreatLow"
                            type="number"
                            value={analiCreatLow}
                            onChange={(e) => setAnaliCreatLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiCreatHigh"
                            type="number"
                            value={analiCreatHigh}
                            onChange={(e) => setAnaliCreatHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* Filtrado Glomerular CKD-EPI empty field  */}
                      <div className="field">
                        <h4>
                          Filtrado Glomerular CKD-EPI <i>(mL/min/1,7)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiGlomResult"
                            type="number"
                            value={analiGlomResult}
                            onChange={(e) => setAnaliGlomResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiGlomLow"
                            type="number"
                            value={analiGlomLow}
                            onChange={(e) => setAnaliGlomLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiGlomHigh"
                            type="number"
                            value={analiGlomHigh}
                            onChange={(e) => setAnaliGlomHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* Aspartato Amino Transferasa empty field  */}
                      <div className="field">
                        <h4>
                          Aspartato Amino Transferasa (AST/GOT), Suero/Pl{" "}
                          <i>(U/L)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiAsparResult"
                            type="number"
                            value={analiAsparResult}
                            onChange={(e) => setAnaliAsparResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiAsparLow"
                            type="number"
                            value={analiAsparLow}
                            onChange={(e) => setAnaliAsparLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiAsparHigh"
                            type="number"
                            value={analiAsparHigh}
                            onChange={(e) => setAnaliAsparHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* Alanina Amino Transferasa empty field  */}
                      <div className="field">
                        <h4>
                          Alanina Amino Transferasa (ALT/GPT), Suero/Pl <i>(U/L)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiAlanResult"
                            type="number"
                            value={analiAlanResult}
                            onChange={(e) => setAnaliAlanResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiAlanLow"
                            type="number"
                            value={analiAlanLow}
                            onChange={(e) => setAnaliAlanLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiAlanHigh"
                            type="number"
                            value={analiAlanHigh}
                            onChange={(e) => setAnaliAlanHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* Gamma Glutamil Transferasa empty field  */}
                      <div className="field">
                        <h4>
                          Gamma Glutamil Transferasa (GGT), Suero/Pl <i>(U/L)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiGammResult"
                            type="number"
                            value={analiGammResult}
                            onChange={(e) => setAnaliGammResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiGammLow"
                            type="number"
                            value={analiGammLow}
                            onChange={(e) => setAnaliGammLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiGammHigh"
                            type="number"
                            value={analiGammHigh}
                            onChange={(e) => setAnaliGammHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* Fosfatasa Alcalina (FA) empty field  */}
                      <div className="field">
                        <h4>
                          Fosfatasa Alcalina (FA), Suero/Pl <i>(U/L)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiFosfResult"
                            type="number"
                            value={analiFosfResult}
                            onChange={(e) => setAnaliFosfResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiFosfLow"
                            type="number"
                            value={analiFosfLow}
                            onChange={(e) => setAnaliFosfLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiFosfHigh"
                            type="number"
                            value={analiFosfHigh}
                            onChange={(e) => setAnaliFosfHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* Bilirrubina total, Suero/Pl empty field  */}
                      <div className="field">
                        <h4>
                          Bilirrubina total, Suero/Pl <i>(mg/dL)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiBiliResult"
                            type="number"
                            value={analiBiliResult}
                            onChange={(e) => setAnaliBiliResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiBiliLow"
                            type="number"
                            value={analiBiliLow}
                            onChange={(e) => setAnaliBiliLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiBiliHigh"
                            type="number"
                            value={analiBiliHigh}
                            onChange={(e) => setAnaliBiliHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* Colesterol, Suero/Pl empty field  */}
                      <div className="field">
                        <h4>
                          Colesterol, Suero/Pl <i>(mg/dL)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiColestResult"
                            type="number"
                            value={analiColestResult}
                            onChange={(e) => setAnaliColestResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiColestLow"
                            type="number"
                            value={analiColestLow}
                            onChange={(e) => setAnaliColestLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiColestHigh"
                            type="number"
                            value={analiColestHigh}
                            onChange={(e) => setAnaliColestHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* Colesterol HDL, Suero/Pl empty field  */}
                      <div className="field">
                        <h4>
                          Colesterol HDL, Suero/Pl <i>(mg/dL)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiColestHdlResult"
                            type="number"
                            value={analiColestHdlResult}
                            onChange={(e) =>
                              setAnaliColestHdlResult(e.target.value)
                            }
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiColestHdlLow"
                            type="number"
                            value={analiColestHdlLow}
                            onChange={(e) => setAnaliColestHdlLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiColestHdlHigh"
                            type="number"
                            value={analiColestHdlHigh}
                            onChange={(e) => setAnaliColestHdlHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* Colesterol LDL, Suero/Pl empty field  */}
                      <div className="field">
                        <h4>
                          Colesterol LDL, Suero/Pl <i>(mg/dL)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiColestLdlResult"
                            type="number"
                            value={analiColestLdlResult}
                            onChange={(e) =>
                              setAnaliColestLdlResult(e.target.value)
                            }
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiColestLdlLow"
                            type="number"
                            value={analiColestLdlLow}
                            onChange={(e) => setAnaliColestLdlLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiColestLdlHigh"
                            type="number"
                            value={analiColestLdlHigh}
                            onChange={(e) => setAnaliColestLdlHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* Triglicéridos, Suero/Pl empty field  */}
                      <div className="field">
                        <h4>
                          Triglicéridos, Suero/Pl <i>(mg/dL)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiTriglResult"
                            type="number"
                            value={analiTriglResult}
                            onChange={(e) => setAnaliTriglResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiTriglLow"
                            type="number"
                            value={analiTriglLow}
                            onChange={(e) => setAnaliTriglLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiTriglHigh"
                            type="number"
                            value={analiTriglHigh}
                            onChange={(e) => setAnaliTriglHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* Calcio, Suero/Pl empty field  */}
                      <div className="field">
                        <h4>
                          Calcio, Suero/Pl <i>(mg/dL)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiCalcResult"
                            type="number"
                            value={analiCalcResult}
                            onChange={(e) => setAnaliCalcResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiCalcLow"
                            type="number"
                            value={analiCalcLow}
                            onChange={(e) => setAnaliCalcLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiCalcHigh"
                            type="number"
                            value={analiCalcHigh}
                            onChange={(e) => setAnaliCalcHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* Hierro, Suero/Pl empty field  */}
                      <div className="field">
                        <h4>
                          Hierro, Suero/Pl <i>(μg/dL)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiHierrResult"
                            type="number"
                            value={analiHierrResult}
                            onChange={(e) => setAnaliHierrResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiHierrLow"
                            type="number"
                            value={analiHierrLow}
                            onChange={(e) => setAnaliHierrLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiHierrHigh"
                            type="number"
                            value={analiHierrHigh}
                            onChange={(e) => setAnaliHierrHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* Sodio, Suero/Pl empty field  */}
                      <div className="field">
                        <h4>
                          Sodio, Suero/Pl <i>(mMol/L)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiSodResult"
                            type="number"
                            value={analiSodResult}
                            onChange={(e) => setAnaliSodResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiSodLow"
                            type="number"
                            value={analiSodLow}
                            onChange={(e) => setAnaliSodLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiSodHigh"
                            type="number"
                            value={analiSodHigh}
                            onChange={(e) => setAnaliSodHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* Potasio, Suero/Pl empty field  */}
                      <div className="field">
                        <h4>
                          Potasio, Suero/Pl <i>(mMol/L)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiPotasResult"
                            type="number"
                            value={analiPotasResult}
                            onChange={(e) => setAnaliPotasResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiPotasLow"
                            type="number"
                            value={analiPotasLow}
                            onChange={(e) => setAnaliPotasLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiPotasHigh"
                            type="number"
                            value={analiPotasHigh}
                            onChange={(e) => setAnaliPotasHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* Vitamina B12, Suero/Pl empty field  */}
                      <div className="field">
                        <h4>
                          Vitamina B12, Suero/Pl <i>(pg/mL)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiVitbResult"
                            type="number"
                            value={analiVitbResult}
                            onChange={(e) => setAnaliVitbResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiVitbLow"
                            type="number"
                            value={analiVitbLow}
                            onChange={(e) => setAnaliVitbLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiVitbHigh"
                            type="number"
                            value={analiVitbHigh}
                            onChange={(e) => setAnaliVitbHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* 25-OH Vitamina D empty field  */}
                      <div className="field">
                        <h4>
                          25-OH Vitamina D <i>(ng/mL)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiVitohResult"
                            type="number"
                            value={analiVitohResult}
                            onChange={(e) => setAnaliVitohResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiVitohLow"
                            type="number"
                            value={analiVitohLow}
                            onChange={(e) => setAnaliVitohLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiVitohHigh"
                            type="number"
                            value={analiVitohHigh}
                            onChange={(e) => setAnaliVitohHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* Acido Folico Folato, Suero/Pl empty field  */}
                      <div className="field">
                        <h4>
                          Acido Folico Folato, Suero/Pl <i>(ng/mL)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiAcidfolResult"
                            type="number"
                            value={analiAcidfolResult}
                            onChange={(e) => setAnaliAcidfolResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiAcidfolLow"
                            type="number"
                            value={analiAcidfolLow}
                            onChange={(e) => setAnaliAcidfolLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiAcidfolHigh"
                            type="number"
                            value={analiAcidfolHigh}
                            onChange={(e) => setAnaliAcidfolHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* Magnesio, Suero/Pl empty field  */}
                      <div className="field">
                        <h4>
                          Magnesio, Suero/Pl <i>(mg/dL)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiMagnResult"
                            type="number"
                            value={analiMagnResult}
                            onChange={(e) => setAnaliMagnResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiMagnLow"
                            type="number"
                            value={analiMagnLow}
                            onChange={(e) => setAnaliMagnLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiMagnHigh"
                            type="number"
                            value={analiMagnHigh}
                            onChange={(e) => setAnaliMagnHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                    </div>
                    <h3>Proteínas</h3>
                    <div className="grid--4col">
                      {/* Ferritina, Suero/Pl empty field  */}
                      <div className="field">
                        <h4>
                          Ferritina, Suero/Pl <i>(ng/mL)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiFerriResult"
                            type="number"
                            value={analiFerriResult}
                            onChange={(e) => setAnaliFerriResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiFerriLow"
                            type="number"
                            value={analiFerriLow}
                            onChange={(e) => setAnaliFerriLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiFerriHigh"
                            type="number"
                            value={analiFerriHigh}
                            onChange={(e) => setAnaliFerriHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* Proteína C Reactiva (PCR), Suero/Pl empty field  */}
                      <div className="field">
                        <h4>
                          Proteína C Reactiva (PCR), Suero/Pl <i>(mg/L)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiProtcResult"
                            type="number"
                            value={analiProtcResult}
                            onChange={(e) => setAnaliProtcResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiProtcLow"
                            type="number"
                            value={analiProtcLow}
                            onChange={(e) => setAnaliProtcLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiProtcHigh"
                            type="number"
                            value={analiProtcHigh}
                            onChange={(e) => setAnaliProtcHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                    </div>
                    <h3>Analitica B</h3>
                    <div className="grid--4col">
                      {/* Cortisol empty field  */}
                      <div className="field">
                        <h4>
                          Cortisol <i>(g/dL)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiCortiResult"
                            type="number"
                            value={analiCortiResult}
                            onChange={(e) => setAnaliCortiResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiCortiLow"
                            type="number"
                            value={analiCortiLow}
                            onChange={(e) => setAnaliCortiLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiCortiHigh"
                            type="number"
                            value={analiCortiHigh}
                            onChange={(e) => setAnaliCortiHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* DHEA empty field  */}
                      <div className="field">
                        <h4>
                          DHEA <i>(ng/mL)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiDheaResult"
                            type="number"
                            value={analiDheaResult}
                            onChange={(e) => setAnaliDheaResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiDheaLow"
                            type="number"
                            value={analiDheaLow}
                            onChange={(e) => setAnaliDheaLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiDheaHigh"
                            type="number"
                            value={analiDheaHigh}
                            onChange={(e) => setAnaliDheaHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                      {/* DHEA-S empty field  */}
                      <div className="field">
                        <h4>
                          DHEA-S <i>(g/mL)</i>
                        </h4>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiDheaSResult"
                            type="number"
                            value={analiDheaSResult}
                            onChange={(e) => setAnaliDheaSResult(e.target.value)}
                            placeholder="Resultado"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiDheaSLow"
                            type="number"
                            value={analiDheaSLow}
                            onChange={(e) => setAnaliDheaSLow(e.target.value)}
                            placeholder="Valor mínimo"
                          />
                        </div>
                      </div>
                      <div className="field">
                        <div className="control">
                          <input
                            className="input"
                            id="analiDheaSHigh"
                            type="number"
                            value={analiDheaSHigh}
                            onChange={(e) => setAnaliDheaSHigh(e.target.value)}
                            placeholder="Valor máximo"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </fieldset>
          </form>
        )}
      </div>
      {!errorLoadMessage && (
        <div id="actions">
          {(diffDate <= 72 || props.userRole.includes("administrador")) && (
            <button
              className="button is-link"
              id="saveButton"
              form="formUpdatelement"
              type="submit"
              disabled={isCreatingButton}
            >
              { isCreatingButton ? <div className="spinner"></div> : 'Guardar' }
            </button>
          )}
          <Link
            className="button is-link is-light"
            to={`../${tratamientoId}/analiticas/${analiticas.id}`}
          >
            Cancelar
          </Link>
          {props.userRole.includes("administrador") && (
            <button
              className="button is-danger"
              id="deleteButton"
              onClick={deleteItem}
              disabled={isDeletingButton}
            >
              {isDeletingButton ? <div className="spinner"></div> : 'Eliminar'}
            </button>
          )}
        </div>
      )}
    </>
  );
}
